import {Field, Form, FormElement, FormRenderProps} from "@progress/kendo-react-form"
import {Button} from "@progress/kendo-react-buttons"
import {Grid, GridColumn} from "@progress/kendo-react-grid"
import {Input} from "@progress/kendo-react-inputs"
import {useEffect, useState} from "react"
import {Link, useLocation} from "react-router-dom"
import {
    fetchVehicleAnnualTests,
    fetchVehicles,
    setIsVehicleRefreshDisabled,
    setRefreshHiddenButton,
    setSearchString,
    toggleVehicleDetailsLoading,
} from "../../containers/MotHistory/motHistorySlice"
import {Vehicle} from "../../containers/Vehicles/vehicleSlice"
import {RootState} from "../../rootReducer"
import {useAppDispatch, useAppSelector} from "../../store"

export default function MotSearchPanel(): JSX.Element {
    const {pathname, search} = useLocation()

    const dispatch = useAppDispatch()
    const vehicles = useAppSelector((state: RootState) => state.containers.motHistory.vehicles)
    const isRefreshButtonHidden = useAppSelector(
        (state: RootState) => state.containers.motHistory.isRefreshButtonHidden,
    )
    const isVehicleRefreshDisabled = useAppSelector(
        (state: RootState) => state.containers.motHistory.isVehicleRefreshDisabled,
    )
    const [registration, setRegistration] = useState<string>()

    const HideHeaderCell = () => <div style={{display: "none"}}></div>

    const refreshMOTHistory = (VehicleRegNo: string) => {
        dispatch(setIsVehicleRefreshDisabled(true))
        dispatch(fetchVehicles(VehicleRegNo, true))
    }

    const searchString = useAppSelector((state: RootState) => state.containers.motHistory.searchString)

    useEffect(() => {
        const values = new URLSearchParams(search)
        const regNumber = values.get("registration")
        const id = values.get("vid")
        if (regNumber !== null && id !== null) {
            setRegistration(regNumber.replace(/\s/g, "").toUpperCase() ?? "")
            dispatch(fetchVehicles(regNumber, false))
            dispatch(toggleVehicleDetailsLoading(true))
            dispatch(fetchVehicleAnnualTests(parseInt(id)))
        }
    }, [dispatch, search])

    const AddLinkCell = (props: {dataItem: Vehicle}) => (
        <td>
            <Link
                style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                }}
                to={`${pathname}`}
                rel={props.dataItem.vehicleId.toString()}
                onClick={(event: any) => {
                    dispatch(toggleVehicleDetailsLoading(true))
                    dispatch(fetchVehicleAnnualTests(parseInt(event.target.rel)))
                }}
            >
                {props.dataItem.registration}
            </Link>
        </td>
    )

    return (
        <>
            <Form
                initialValues={{vehicleSearch: searchString}}
                key={JSON.stringify({vehicleSearch: registration})}
                render={(formRenderProps: FormRenderProps) => (
                    <div
                        className="mb-2"
                        style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "end",
                        }}
                    >
                        <FormElement style={{width: "100%"}}>
                            <fieldset className={"k-form-fieldset"}>
                                <Field
                                    name={"vehicleSearch"}
                                    onChange={event => {
                                        dispatch(
                                            setSearchString(
                                                formRenderProps.valueGetter("vehicleSearch").replaceAll(" ", ""),
                                            ),
                                        )
                                        if (event.value.trim().length >= 2)
                                            dispatch(
                                                fetchVehicles(
                                                    formRenderProps.valueGetter("vehicleSearch").replaceAll(" ", ""),
                                                    false,
                                                ),
                                            )
                                        else if (event.value == "") dispatch(setRefreshHiddenButton(false))
                                    }}
                                    label={"Search vehicle"}
                                    component={Input}
                                />
                            </fieldset>
                        </FormElement>
                        <Button
                            type="button"
                            fillMode="link"
                            themeColor={"primary"}
                            size="small"
                            title="Refresh from DVSA"
                            icon="refresh"
                            hidden={!isRefreshButtonHidden}
                            disabled={isVehicleRefreshDisabled}
                            onClick={() => refreshMOTHistory(formRenderProps.valueGetter("vehicleSearch"))}
                        />
                    </div>
                )}
            />
            {vehicles.length > 0 && (
                <>
                    <Grid
                        data={vehicles}
                        style={{
                            height: "calc(100vh - 14.35rem)",
                        }}
                    >
                        <GridColumn
                            field="registration"
                            cell={props => <AddLinkCell {...props} />}
                            headerCell={HideHeaderCell}
                        />
                    </Grid>
                </>
            )}
        </>
    )
}
